/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { valToBool } from "./index";

const isLegacyDomain = valToBool(process.env.REACT_APP_IS_LEGACY_CONNECT_DOMAIN);

const connectEndpoint = isLegacyDomain
	? `https://${process.env.REACT_APP_CONNECT_INSTANCE_NAME}.awsapps.com/connect`
	: `https://${process.env.REACT_APP_CONNECT_INSTANCE_NAME}.my.connect.aws`;

const Connect = {
	ccp: `${connectEndpoint}/ccp-v2`,
	customerProfiles: `${connectEndpoint}/customerprofiles-v2`,
	wisdom: `${connectEndpoint}/wisdom-v2`,
	login: process.env.REACT_APP_CONNECT_LOGIN_URL,
	logout: isLegacyDomain ? `${connectEndpoint}/logout` : `${connectEndpoint}/connect/logout`,
	connectConsole: connectEndpoint,
};

// Other endpoints for APIs, etc.

export default Connect;
